import { svg } from 'lit';

export const backIcon = svg`
  <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <path d="M1.26 15.4c.33 0 .62-.11.86-.35l6.44-6.37a1.32 1.32 0 000-1.96L2.12.35A1.16 1.16 0 001.26 0C.56 0 0 .55 0 1.24c0 .34.15.65.4.9L6.04 7.7.4 13.27c-.25.24-.4.56-.4.9 0 .69.56 1.23 1.26 1.23z" id="back-a"/>
    </defs>
  <use fill="#626262" fill-rule="nonzero" transform="rotate(-180 9.5 11.2)" xlink:href="#back-a"/>
</svg>`;
